import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 14 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#FF7839",
      "fill-rule": "nonzero",
      d: "M12.98 0H1.02C.51 0 0 .416 0 .97v14.197c0 .346.073.623.438.761.437.208 1.02-.069 1.75-.415 1.094-.554 2.77-1.316 3.864-1.8.583-.277 1.313-.277 1.969 0 1.02.484 2.698 1.246 3.792 1.8.729.346 1.312.554 1.75.415.291-.138.437-.484.437-.761V.97C13.927.415 13.49 0 12.98 0Zm-2.888 6.228-.928 1.129a1.345 1.345 0 0 0-.207.638l.052 1.473c0 .196-.155.294-.361.245l-1.444-.49a1.788 1.788 0 0 0-.722 0l-1.444.49c-.206.05-.361-.049-.361-.245l.051-1.473c0-.196-.103-.49-.206-.638l-.928-1.129c-.104-.147-.052-.343.155-.393l1.495-.393c.206-.049.464-.245.567-.392l.877-1.227a.245.245 0 0 1 .207-.11c.084 0 .162.041.206.11l.877 1.227c.103.147.36.343.567.393l1.495.393c.104.049.155.245.052.392Z"
    }, null, -1)
  ])))
}
export default { render: render }